import type { ApiQuestion, ApiQuestionDisplayVariant } from '../../../../internalTypes';
import type { QuestionDisplayVariant } from '../../../../types/survey';
import { mapDisplayLogic } from './mapDisplayLogic';

function resolveVariantText(
  raw: ApiQuestionDisplayVariant,
  language?: string,
  placeholders?: Record<string, string>
): string {
  let questionText: string =
    (language && raw.translations?.[language]?.questionRichText) ||
    (language && raw.translations?.[language]?.questionText) ||
    raw.questionRichText ||
    raw.questionText ||
    '';

  if (placeholders) {
    questionText = questionText.replace(/\{\{(\w+)\}\}/g, (match: string, key: string) =>
      placeholders[key] !== undefined ? placeholders[key] : match
    );
  }

  return questionText;
}

export function mapQuestionDisplayVariants(
  raw: ApiQuestion,
  language?: string,
  placeholders?: Record<string, string>
): QuestionDisplayVariant[] | undefined {
  const variants = raw.questionDisplayVariants;
  if (!variants?.length) return undefined;

  const mapped: QuestionDisplayVariant[] = [];

  for (const variant of variants) {
    const id = variant.id;
    if (!id) continue;

    const questionText = resolveVariantText(variant, language, placeholders);
    if (!questionText) continue;

    const displayLogic = mapDisplayLogic(variant.controlConfig?.displayLogic);

    if (!displayLogic) continue;

    mapped.push({
      id,
      questionText,
      ...(displayLogic ? { displayLogic } : {}),
    });
  }

  return mapped.length > 0 ? mapped : undefined;
}
